import { useLocation } from "react-router-dom";

import { QUICK_MENU_HOME, QUICK_MENU_URLS } from "@/constants/quickMenu";
import { isPathActive } from "@/lib/navigation";
import { pickQuickMenu } from "@/lib/quickMenu";
import { useQuickMenuStore } from "@/store/useQuickMenuStore";
import type { QuickMenuItem } from "@/types/quickMenu";

import { useNavSections } from "./useNavSections";

/**
 * 자주찾는 메뉴 — 첫 칸은 홈(`/home`), 나머지는 사용자가 고른 페이지(고른 적이 없으면
 * `QUICK_MENU_URLS`)를 메뉴 정의의 순서대로 보여준다.
 *
 * `useNavSections()` 를 거치므로 헤더·사이드바와 같은 규칙(활성 팀, 관리자 전용 항목
 * 숨김)이 그대로 적용된다 — 이 팀이나 이 사용자의 메뉴에 없는 페이지는, 예전에
 * 골라 두었더라도 칸이 만들어지지 않는다. `isActive` 는 헤더와 같은 `isPathActive` 로
 * 구한다.
 */
export function useQuickMenu(): QuickMenuItem[] {
  const { pathname } = useLocation();
  const sections = useNavSections();
  const selectedUrls = useQuickMenuStore((state) => state.selectedUrls);

  const picked = pickQuickMenu(sections, selectedUrls ?? QUICK_MENU_URLS);

  return [QUICK_MENU_HOME, ...picked].map(({ title, url, icon }) => ({
    title,
    url,
    icon,
    isActive: isPathActive(pathname, url),
  }));
}
